// extracted by mini-css-extract-plugin
export default {"version":"bw_gM"};